<template>
<div class="row-jumbotron">
  <div class="column-jumbotron">
      <div class="container-text-jumbotron">
        <img class="gambar-area-one" src="https://res.cloudinary.com/dulqd0xea/image/upload/v1609849428/Ice%20Message%20Indonesia/pexels-cottonbro-5076530_q9lisn.jpg"/>
    </div>
    
    <div>
     <img class="gambar-area-two" src="https://res.cloudinary.com/dulqd0xea/image/upload/v1609849426/Ice%20Message%20Indonesia/pexels-kevin-ku-577585_vgioja.jpg"/>
     </div>
  </div>

  <div>
        <p class="text-jumbotron"><strong>Booked Tool</strong> enables you to <br/> create Interactive Advertisement</p>
        <button class="button-jumbotron">What is it ?</button>
    </div>
</div>
</template>

<script>
import "../styles/Jumbotron.scss"

export default {
    name: "Jumbotronsection"
}
</script>